"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdapterFactory = void 0;
const http_1 = require("./http");
const DuplicateRequestDetector_1 = require("./http/utils/DuplicateRequestDetector");
const service_1 = require("./service");
const SocketAdapter_1 = require("./ws/SocketAdapter");
class AdapterFactory {
    /**
     * Construct the AdapterFactory. The host app builds its `SessionManager`
     * (via `createSessionManager` from `@home-health-notify/auth`) once at
     * boot and passes it in here. The factory extracts what each consumer
     * needs internally:
     *   - HTTP interceptors get `sessionManager.getAccessTokenProvider()` —
     *     the narrow `IAccessTokenProvider` view (just `getAccessToken()`).
     *   - Domain classes get `sessionManager.getAdapter()` via
     *     `createAuthAdapter()` — the wide `IAuthAdapter` surface, needed
     *     for `isAuthenticated`, `signInWithRedirect`, `clearAuthSession`,
     *     etc.
     *
     * Taking SessionManager here (rather than the raw adapter) keeps the
     * two-tier auth API from leaking into app-level bootstrap wiring — the
     * app passes ONE reference (`sessionManager`) instead of reaching for
     * `sessionManager.getAdapter()` inline.
     */
    constructor(config, sessionManager, axios) {
        this.config = config;
        this.sessionManager = sessionManager;
        this.axios = axios;
    }
    createAuthAdapter() {
        return this.sessionManager.getAdapter();
    }
    createHttpAdapter(accessTokenProvider, internetStatusManager) {
        this.internetStatusManager = internetStatusManager;
        return new http_1.HttpAdapter(accessTokenProvider, this.config, this.axios, this.authStatusManager, new DuplicateRequestDetector_1.DuplicateRequestDetector(), internetStatusManager);
    }
    createOrgHttpAdapter(organizationId) {
        return new http_1.HttpAdapter(this.sessionManager.getAccessTokenProvider(), this.config, this.axios, this.authStatusManager, new DuplicateRequestDetector_1.DuplicateRequestDetector(), this.internetStatusManager, organizationId);
    }
    createSocketAdapter(accessTokenProvider) {
        return new SocketAdapter_1.SocketAdapter(accessTokenProvider, this.config, this.authStatusManager);
    }
    createStorageAdapter(httpAdapter) {
        return new service_1.S3Storage(this.config, this.authStatusManager, httpAdapter);
    }
    withAuthStatusManager(authStatusManager) {
        this.authStatusManager = authStatusManager;
        return this;
    }
}
exports.AdapterFactory = AdapterFactory;
